

































import Vue from 'vue'
import moment from 'moment'
import warningImg from '@/utils/warningImg'
import request from '@/utils/request'
export default Vue.extend({
  async mounted() {
    //@ts-ignore
    this.articleId = this.$route.query.id
    await this.getData()
  },
  computed: {
    getFontSize() {
      switch (this.font_type) {
        case 'big':
          return '20px';
        case 'middle':
          return '18px';
        case 'small':
        default:
          return '16px';
      }
    }
  },
  data() {
    return {
      articleId: "" as string,
      data: undefined as any,
      title: '',
      font_type: 'middle',
    }
  },

  methods: {

    getData() {
      request.get(`/api/column/rest_article/${this.articleId}`).then((data) => {
        this.data = data
        const categoryId = data.categoryId
        const title: string = data.title
        this.data.imgUrl = "/static/warningIcon/warn_zhongyaojingshi.jpg"
        //@ts-ignore
        document.title = '重要警示'

      })
    },
    changeFontSize(type: string) {
      this.font_type = type
    }

  },
  filters: {
    dtFormat(timestamp: number) {
      const time = moment(timestamp)
      return time.format('YYYY-MM-DD HH:mm:ss')
    },
  },
})
